module.exports = __webpack_public_path__ + "static/media/bkg-3-dsk.ce718678.jpg";